import * as React from 'react';
import { ListingState, BaseRouteProps } from '../../interfaces';
import { Survey } from '../../models';
import { SurveyDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { DataGrid, PVAPage } from '../../components';

export class SurveyListing extends React.Component<BaseRouteProps<{}>, ListingState<Survey>> {
    private surveyDataService = new SurveyDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            entities: new Array<Survey>(),
        };
    }

    public componentDidMount() {
        this.surveyDataService.getAll().then((surveys: Survey[]) => {
            this.setState(
                { entities: surveys }
            );
        });
    }

    public render() {
        const listData = this.state.entities.map(entity => {
            return {
                'Name': entity.name,
                'ActionKey': entity.id
            };
        });

        const actionsColumn = ({ value }: any) => {
            return (
                <span>
                    <NavLink className="btn btn-default" to={`/survey/${value}`}>View</NavLink>
                </span>
            );
        };

        const columnDefs = [
            { id: 'Name' },
            { id: 'ActionKey', title: 'Actions', width: '88px', customComponent: actionsColumn, sortable: false }
        ];

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            Surveys available to selected tenant
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                    <PVAPage.Header.Buttons>
                        <NavLink className="btn btn-primary" to="/survey/create">
                            <span className="glyphicon glyphicon-plus" /> Create
                        </NavLink>
                    </PVAPage.Header.Buttons>
                </PVAPage.Header>

                <PVAPage.Body>
                    <DataGrid entities={listData} columns={columnDefs} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }
}


// WEBPACK FOOTER //
// ./src/components/survey/SurveyListing.tsx